import polyfillContains from '../common/polyfills/Node/prototype/contains';
import 'whatwg-fetch';
import 'jspolyfill-array.prototype.findIndex';
import 'jspolyfill-array.prototype.find';
import { PermissionCoreApp } from './app/permission-core-app';
import * as Logger from '../common/tools/logger';
import { initSentry, sentryAppender } from '../common/tools/sentry';
import { CONFIG_SENTRY_DSN } from '../config';

if (CONFIG_SENTRY_DSN.length > 0) {
  initSentry();
  Logger.registerAppender(sentryAppender);
}

polyfillContains();

export default new PermissionCoreApp();
